export default {
    nav: {
        subject: "通知內容"
    }
}
